import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';

const Model = () => {
  const [isOpen, setIsOpen] = useState(true);

  const closePopup = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div>
      {/* Backdrop - poora screen cover + click se close */}
      <div
        onClick={closePopup}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#0000008f',
          zIndex: 9998,
          cursor: 'pointer',
        }}
      />

      {/* Modal Box - backdrop ke upar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '15px',
          pointerEvents: 'none', 
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()} 
          style={{
            maxWidth: '490px',
            width: '100%',
            maxHeight: '95vh',
            backgroundColor: '#000',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
            pointerEvents: 'auto', 
            position: 'relative',
          }}
        >
          {/* Close Button */}
          <button
            onClick={closePopup} class="closenew"
            style={{              
              cursor: 'pointer',
              zIndex: 10,              
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,0,0,0.7)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.6)'}
          >
            <CgClose size={28} color="#fff" />
          </button>

          {/* Scrollable Image */}
          <div
            style={{
              maxHeight: '95vh',
              overflowY: 'auto',
              scrollbarWidth: 'thin',
              scrollbarColor: '#555 #000',
            }}
          >
            <img src='model.png' alt='' className='w-100' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Model;